export const APPROVAL_CHAIN_TEMPLATE_LEVEL_USER_MODEL =
  "approval-chain-template-level-user";

const approvalChainTemplateLevelUserModel = {
  userId: 0,
  user: {
    jsonApi: "hasOne",
    type: "users"
  }
};

export default approvalChainTemplateLevelUserModel;
